import { render } from "./ForStock.vue?vue&type=template&id=60cd9a8a&scoped=true&ts=true"
import script from "./ForStock.vue?vue&type=script&lang=ts"
export * from "./ForStock.vue?vue&type=script&lang=ts"

import "./ForStock.vue?vue&type=style&index=0&id=60cd9a8a&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cd9a8a"]])

export default __exports__